/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: false,
  base_url: 'https://api.easyvta.io',
  dev_url : 'https://api-dev.easyvta.com',
  staging_url : 'https://api-staging.easyvta.com',
  production_url : 'https://api-v1.easyvta.com'
};
